var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9835 3.33337H13.0168C6.95016 3.33337 3.3335 6.95004 3.3335 13.0167V26.9667C3.3335 33.05 6.95016 36.6667 13.0168 36.6667H26.9668C33.0335 36.6667 36.6502 33.05 36.6502 26.9834V13.0167C36.6668 6.95004 33.0502 3.33337 26.9835 3.33337ZM26.6668 21.25H21.2502V26.6667C21.2502 27.35 20.6835 27.9167 20.0002 27.9167C19.3168 27.9167 18.7502 27.35 18.7502 26.6667V21.25H13.3335C12.6502 21.25 12.0835 20.6834 12.0835 20C12.0835 19.3167 12.6502 18.75 13.3335 18.75H18.7502V13.3334C18.7502 12.65 19.3168 12.0834 20.0002 12.0834C20.6835 12.0834 21.2502 12.65 21.2502 13.3334V18.75H26.6668C27.3502 18.75 27.9168 19.3167 27.9168 20C27.9168 20.6834 27.3502 21.25 26.6668 21.25Z",
    fill: "#F15A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.63cfc1c39323bd9ef606605acd024295.svg";
export { ForwardRef as ReactComponent };